// extracted by mini-css-extract-plugin
export default {"list":"ModifierGroupAttach_list__e47Y2","row":"ModifierGroupAttach_row__svhHr","hint":"ModifierGroupAttach_hint__kdfQ-"};